import { Task } from "~/packages/taskrouter";
import { ErrorCode, ErrorSeverity, FlexSdkError } from "~/modules/error";
import { getLogger, LoggerName } from "~/modules/logger";
import { TaskRouterImpl } from "~/packages/taskrouter/TaskRouterImpl";
import { ContextInstance, ContextManager } from "~/modules/contextManager/ContextManager";
import { getReservationsByTask, isCallTask, sendTrackingEvent } from "../../ActionUtils";
import { EVENTS } from "~/modules/analytics/Analytics";
import { AnalyticsImpl } from "~/modules/analytics/AnalyticsImpl";
import { Action } from "~/modules/actions/Action";



















export class CancelVoiceTaskTransfer implements Action<Promise<Task>> {
    


    #taskSid: string;

    constructor(taskSid: string) {
        this.#taskSid = taskSid;
    }

    async run(ctx: {}) {
        const context = ctx as ContextManager;
        const taskRouter = context.retrieveInstanceOf(ContextInstance.TaskRouter, TaskRouterImpl);
        await taskRouter.init();
        const logger = getLogger(context)(LoggerName.Actions);
        const worker = taskRouter.worker;
        const analytics = context.retrieveInstanceOf(ContextInstance.AnalyticsImpl, AnalyticsImpl);

        logger.debug(`cancelVoiceTaskTransfer invoked with taskSid: ${this.#taskSid}`);

        if (!worker) {
            const errorMsg = "cancelVoiceTaskTransfer: worker is not initialized";
            logger.error(errorMsg);
            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }

        const reservations = getReservationsByTask(worker, this.#taskSid);
        const reservation = reservations.find((res) => res.status === "accepted");

        if (!reservation) {
            const errorMsg = `cancelVoiceTaskTransfer: Reservation for task ${this.#taskSid} is not found`;
            logger.error(errorMsg);
            sendTrackingEvent(EVENTS.CancelVoiceTaskTransfer, analytics, worker, {
                error: errorMsg,
                taskSid: this.#taskSid
            });
            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }

        if (!isCallTask(reservation.task)) {
            const errorMsg = `cancelVoiceTaskTransfer: Reservation for task ${this.#taskSid} is not an active call`;
            logger.error(errorMsg);
            sendTrackingEvent(EVENTS.CancelVoiceTaskTransfer, analytics, worker, {
                error: errorMsg,
                taskSid: this.#taskSid,
                reservationSid: reservation.sid
            });
            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }

        if (!reservation.task?.transfers?.outgoing) {
            const errorMsg = `cancelVoiceTaskTransfer: Reservation for task ${this.#taskSid} has
            no outgoing transfer to cancel`;
            logger.error(errorMsg);
            sendTrackingEvent(EVENTS.CancelVoiceTaskTransfer, analytics, worker, {
                error: errorMsg,
                taskSid: this.#taskSid,
                reservationSid: reservation.sid
            });
            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }
        try {
            const outgoingTransfer = reservation.task.transfers.outgoing;
            await outgoingTransfer.cancel();

            sendTrackingEvent(EVENTS.CancelVoiceTaskTransfer, analytics, worker, {
                taskSid: this.#taskSid,
                reservationSid: reservation.sid,
                outgoingTransferSid: outgoingTransfer.sid
            });

            return reservation.task;
        } catch (error) {
            const errorMsg = `cancelVoiceTaskTransfer: Could not transfer task: ${error.message}`;
            sendTrackingEvent(EVENTS.CancelVoiceTaskTransfer, analytics, worker, {
                error: errorMsg,
                taskSid: this.#taskSid,
                reservationSid: reservation.sid
            });
            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }
    }
}
